import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import Container from './PictureCardContainer'

import { Card } from 'semantic-ui-react'

import PictureCardActions from 'Components/PictureCard/PictureCardActions'
import PictureCardInformation from 'Components/PictureCard/PictureCardInformation'
import PictureCardPicture from 'Components/PictureCard/PictureCardPicture'
import PictureCardPictureTypes from 'Components/PictureCard/PictureCardPictureTypes'

import { getCardColor } from './helpers'

const PictureCard = props => {
  const { pending, picture, setPrimary, togglePreview, uploadDesignerPicture } = props

  return (
    <Card color={getCardColor(picture)} fluid>
      <PictureCardPicture isPending={pending} picture={picture} togglePreview={togglePreview} />

      <PictureCardInformation picture={picture} togglePreview={togglePreview} />

      <PictureCardPictureTypes picture={picture} />

      <PictureCardActions picture={picture} setPrimary={setPrimary} uploadDesignerPicture={uploadDesignerPicture} />
    </Card>
  )
}

PictureCard.propTypes = {
  error: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  pending: PropTypes.bool.isRequired,
  picture: PropTypes.object.isRequired,
  rug: PropTypes.object.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
  setPrimary: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
  uploadDesignerPicture: PropTypes.func.isRequired,
}

const composed = compose(Container)

export default composed(PictureCard)
